export const addZ = (dateString: string) =>
  dateString?.endsWith("Z") ? dateString : `${dateString}Z`;
